module.exports = __webpack_public_path__ + "static/FoundersGrotesk-Regular-4eaa69b7eb20ab81b099caa06b521a07.woff";